define([
	"dojo/_base/array",
	"dojo/_base/declare",
	"ProductSpec/SizeChart/CustomViewSizeChartOptions",
	"SiteAdmin/DataSheetTablePreferences",
	"../SizeChart",
	"./_SizeChartTableMixin",
	"./Table"
], function(array,declare,{SizeChartDimensionFormatType},DataSheetTablePreferences,SizeChart,_SizeChartTableMixin,Table) {

	var	_Preferences = declare(DataSheetTablePreferences, {
		constructor: function() {
			this.addCustomOption("sizeChartUnits", SizeChart.valueUnits, false, "SizeChartUnits");
			this.addCustomOption("sizeChartDimensionFormat", SizeChartDimensionFormatType.DEFAULT, false, "SizeChartDimensionFormat");
			this.addCustomOption("sizeChartHighlightActualOutOfTolerance", true, false, "SizeChartHighlightActualOutOfTolerance");
			this.addCustomOption("sizeChartHighlightDeltaOutOfTolerance", true, false, "SizeChartHighlightDeltaOutOfTolerance");
		}
	});

	return declare([Table,_SizeChartTableMixin], {
		prefClass: _Preferences,

		// Number: index of Sample.ProductSize in SizeChartRevision.Sizes
		_nSizeIndex: null,

		// String: SampleDimensions url
		_urlSampleDims: null,

		onContext: function(/*Context*/ctx) {
			// summary: set context to read-only so that dimensions cannot be edited, other than actual column which overrides this setting
			this.inherited(arguments);
			ctx.setReadOnly(true);
		},

		onViewStart: function(/*Deferred[]*/dfds) {
			// summary: cache url values for Sample data to help target and actual renderers
			this.relRoot.m_url = this.viewParent.getSizeChart().$URL;
			this.inherited(arguments);
		},

		onViewStartBuild: function() {
			// summary: reset cached size range data after each query for data
			this.resetSubSizeRangeData();
			this.resetSizeChartRevisionData();
			
			// determine size and base size indices to calculate target value for sample dimensions
			var sample = this.getViewNode();
			var sampleDims = this.cacheView.getNode(sample.Dimensions);
			var scr = this.viewParent.getSizeChartRevision();
			
			this._nSizeIndex = array.indexOf(scr.Sizes, sample.ProductSize);
			
			if (sampleDims && (this._nSizeIndex >= 0)) {
				this._urlSampleDims = sampleDims.$URL;
			}
		}
	});
});